import { Switch, TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface SummaryFieldInputProps {
  name: string;
  originalValue: unknown;
  control: Control<any>;
}

export default function SummaryFieldInput({ name, originalValue, control }: Readonly<SummaryFieldInputProps>) {
  if (typeof originalValue === "boolean") {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Switch checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)} />
        )}
      />
    );
  }

  const isNumber = typeof originalValue === "number";

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          type={isNumber ? "number" : "text"}
          size="small"
          value={field.value ?? ""}
          onChange={(e) => field.onChange(isNumber ? Number(e.target.value) : e.target.value)}
        />
      )}
    />
  );
}